import { ReceitaPdfTemplate } from './templates/receitaPdfTemplate';
import type { ReceitaCompleta } from '@/types/receita';
import { PdfHeaderData } from '@/types/pdf';
import { registrarImpressao } from '@/lib/printLog';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export async function gerarPdfReceita(
  receita: ReceitaCompleta,
  nomeEmpresa: string,
  nomeUsuario: string
): Promise<{ success: boolean; error?: string }> {
  try {
    // Dados do cabeçalho
    const headerData: PdfHeaderData = {
      empresa: nomeEmpresa,
      titulo: receita.receita.nome,
      impressaPor: nomeUsuario,
      dataImpressao: format(new Date(), "dd/MM/yyyy 'às' HH:mm", { locale: ptBR }),
      geradoPor: nomeUsuario,
    };

    // Gerar PDF
    const pdfTemplate = new ReceitaPdfTemplate();
    pdfTemplate.generate(receita, headerData);

    // Baixar PDF
    const filename = `Receita_${receita.receita.nome.replace(/\s+/g, '_')}_${format(new Date(), 'yyyyMMdd_HHmmss')}.pdf`;
    pdfTemplate.download(filename);

    // Registrar impressão no banco
    const tamanhoKB = pdfTemplate.getSizeInKB();
    
    await registrarImpressao({
      tipo_documento: 'receita',
      documento_id: receita.receita.id_receita,
      documento_nome: receita.receita.nome,
      formato_pagina: 'A4',
      orientacao: 'portrait',
      arquivo_tamanho_kb: tamanhoKB,
    });

    return { success: true };
  } catch (error) {
    console.error('Erro ao gerar PDF:', error);
    return { 
      success: false, 
      error: error instanceof Error ? error.message : 'Erro desconhecido' 
    };
  }
}
